import React from 'react'
import { Modal } from '../../../../../../../components/Modal/Modal'
import { Button } from '../../../../../../../components/Button/Button'

interface ConfirmDeleteFilterModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  loading?: boolean
}

export const ConfirmDeleteFilterModal: React.FC<ConfirmDeleteFilterModalProps> = ({ show, onHide, onConfirm, loading = false }) => {
  const body = (
    <div className='d-flex flex-column align-items-center text-center gap-4 py-3'>
      <h4 className='fw-bold mb-0'>Confirm Deletion</h4>
      <p className='paragraph-medium mb-0'>Are you sure you want to delete this filter group?</p>
    </div>
  )

  const footer = (
    <div className='d-flex gap-3 w-100'>
      <Button variant='secondary' className='flex-grow-1' onClick={onHide}>
        Cancel
      </Button>
      <Button variant='danger' className='flex-grow-1' onClick={onConfirm} loading={loading}>
        Delete
      </Button>
    </div>
  )

  return <Modal show={show} onHide={onHide} centered header={<></>} body={body} footer={footer} />
}
